<script lang="ts">
  import Button from '$components/button/Button.svelte';
  import BottomSheetBody from '$components/bottom-sheet/BottomSheetBody.svelte';
  import { closeModal } from '$components/bottom-sheet/index.svelte';
  import IconShareUpRight from '$lib/icons/IconShareUpRight.svelte';
</script>

<BottomSheetBody>
  <div class="grid w-full gap-4 pt-12">
    <div class="typography-h4-semibold">Wallet Owner Not Found</div>
    <div class="typography-body-l-regular text-foreground-default">
      The passkey you are trying to use is not an owner of this account anymore. This can happen if
      you removed the passkey as an owner of the on-chain Metri Safe Account.
      <br />
      <br />
      You can try to import the account using a different passkey or using a seedphrase from an EOA that
      is a Metri Safe owner.
      <br />
      <br />

      <div class="grid w-full pt-2">
        <a
          href="https://discord.com/invite/aboutcircles"
          target="_blank"
          class="relative z-10 flex gap-2 text-center typography-body-l-semibold underline">
          Need more help? Join our Discord
          <IconShareUpRight />
        </a>
      </div>
    </div>
    <div class="w-full pt-8">
      <Button
        ariaLabel="Passkey Troubleshooting"
        stretched
        variant="tertiary"
        onclick={() => {
          closeModal();
        }}>
        Close
      </Button>
    </div>
  </div>
</BottomSheetBody>
